import { z } from "zod";
import { claimIdSchema, connectionIdSchema, documentBlockIdSchema, documentVersionIdSchema, entityIdSchema, evidenceIdSchema, memberIdSchema, relationIdSchema, sourceItemIdSchema, tenantIdSchema, } from "./ids.js";
export const memberRefSchema = z
    .object({ tenantId: tenantIdSchema, memberId: memberIdSchema })
    .strict();
export const connectionRefSchema = z
    .object({ tenantId: tenantIdSchema, connectionId: connectionIdSchema })
    .strict();
export const sourceItemRefSchema = z
    .object({ tenantId: tenantIdSchema, sourceItemId: sourceItemIdSchema })
    .strict();
export const documentVersionRefSchema = z
    .object({
    tenantId: tenantIdSchema,
    documentVersionId: documentVersionIdSchema,
})
    .strict();
export const documentBlockRefSchema = z
    .object({ tenantId: tenantIdSchema, documentBlockId: documentBlockIdSchema })
    .strict();
export const entityRefSchema = z
    .object({ tenantId: tenantIdSchema, entityId: entityIdSchema })
    .strict();
export const claimRefSchema = z
    .object({ tenantId: tenantIdSchema, claimId: claimIdSchema })
    .strict();
export const evidenceRefSchema = z
    .object({ tenantId: tenantIdSchema, evidenceId: evidenceIdSchema })
    .strict();
export const relationRefSchema = z
    .object({ tenantId: tenantIdSchema, relationId: relationIdSchema })
    .strict();
//# sourceMappingURL=refs.js.map